export const formatSecondsToTime = (secondsFloat: number) => {
  if (Number.isNaN(secondsFloat)) {
    return '00:00'
  }
  const totalSeconds = Math.round(secondsFloat)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}
